<template>
  <md-card class="md-card-profile">
    <div class="md-card-avatar">
      <div class="picture-container">
        <div class="picture" @click="clickAvatar">
          <div v-if="!image">
            <img :src="cardUserImage" class="picture-src" title="" />
          </div>
          <div v-else>
            <img :src="image" />
          </div>
          <input
            style="display: none"
            id="avatar"
            type="file"
            accept="image/*"
            @change="onFileChange"
          />
        </div>
      </div>
    </div>

    <md-card-content>
      <h4 class="category text-gray">
        <b>{{ $store.role_name }} User</b>
      </h4>
      <h4 class="card-title">
        <b>Full Name :</b> {{ $store.first_name }} {{ $store.last_name }}
      </h4>
      <h5 class="card-title"><b>Email :</b> {{ $store.email }}</h5>
    </md-card-content>
  </md-card>
</template>
<script>
export default {
  name: "user-card",
  props: {
    cardUserImage: {
      type: String,
      default: "/img/default-avatar.png"
    },
    buttonColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      image: ""
    };
  },
  methods: {
    getColorButton: function(buttonColor) {
      return "md-" + buttonColor + "";
    },
    onFileChange(e) {
      var file = e.target.files[0] || e.dataTransfer.files[0];
      this.$store
        .updateAvatar(file)
        .then(response => {
          this.$notify({
            message: "Upload Successful",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {});
      this.$notify({
        message: "Uploading...",
        icon: "add_alert",
        type: "info",
        verticalAlign: "top",
        timeout: 3000
      });
      // if (!files.length) return;
      // this.createImage(files[0]);
    },
    clickAvatar: function() {
      document.getElementById("avatar").click();
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = e => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>
<style></style>
